<template>
  <a-steps :current="currentStep"
           labelPlacement="vertical"
           class="mb40">
    <a-step v-for="step in stepList"
            :key="step.id"
            :status="step.status"
            :title="step.title"
            disabled/>
  </a-steps>
</template>

<script>
export default {
  name: 'BindSteps',
  props: {
    step: {
      type: Number,
      required: true,
    },
    secondStepTitle: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      currentStep: 0,
      stepList: [
      {
          id: 'type',
          title: '选择验证方式',
          status: 'process',
        },
        {
          id: 'cert',
          title: '验证身份',
          status: 'wait',
        },
        {
          id: 'change',
          title: '',
          status: 'wait',
        },
        {
          id: 'finish',
          title: '完成',
          status: 'wait',
        }
      ],
    }
  },
  created() {
    this.stepList[2].title = this.secondStepTitle
  },
  watch: {
    step: {
      handler(step) {
        this.currentStep = step
        if (step === 1) {
          this.stepList[0].status = 'finish'
          this.stepList[1].status = 'finish'
        } else if (step === 2) {
          this.stepList[0].status = 'finish'
          this.stepList[1].status = 'finish'
          this.stepList[2].status = 'finish'
        }else if (step === 3) {
          this.stepList[0].status = 'finish'
          this.stepList[1].status = 'finish'
          this.stepList[2].status = 'finish'
          this.stepList[3].status = 'finish'
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/* ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #fff;
} */
</style>



// WEBPACK FOOTER //
// src/components/user/account/BindSteps.vue